import { Helmet } from "react-helmet";

export default function SEO({
  title = "Diseño y desarrollo web personalizado",
  description = "Creamos páginas web modernas, responsivas y optimizadas para negocios grandes y pequeños. Conecta con más clientes con RedDigitalCreations.",
  keywords = [
  "diseño web",
  "desarrollo web",
  "páginas web para negocios",
  "landing page",
  "catálogo digital",
  "menú digital",
  "sitios web económicos",
  "sitios web para empresas pequeñas",
  "diseño web profesional",
  "web para doctores",
  "web para pymes",
  "RedDigitalCreations",
  "programador web en México",
  "crear página web",
  "diseño responsivo",
  "sitios modernos",
  "portafolio web",
  "tarjeta digital",
  "formulario de contacto",
  "SEO para sitios web"
],
  url = "https://reddigitalcreations.com",
  //image = "https://tudominio.com/og-image.png", // REEMPLAZA con tu imagen OG real
}) {
  return (
    <Helmet>
      {/* Título y descripción básica */}
      <title>{title} | RedDigitalCreations</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(", ")} />
      <meta name="author" content="RedDigitalCreations" />
      <meta name="robots" content="index, follow" />
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
      <meta property="og:title" content={title + " | RedDigitalCreations"} />
      <meta property="og:description" content={description} />
      {/* <meta property="og:image" content={image} /> */}
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title + " | RedDigitalCreations"} />
      <meta name="twitter:description" content={description} />
      {/* <meta name="twitter:image" content={image} /> */}
    </Helmet>
  );
}